import React from 'react';

const CloseSliderIcon = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.9974 29.3337C23.3612 29.3337 29.3307 23.3641 29.3307 16.0003C29.3307 8.63653 23.3612 2.66699 15.9974 2.66699C8.6336 2.66699 2.66406 8.63653 2.66406 16.0003C2.66406 23.3641 8.6336 29.3337 15.9974 29.3337Z'
        fill='#FBFBFB'
        fillOpacity='0.8'
      />
      <path
        d='M15.9971 3.16699C23.0846 3.16699 28.8309 8.9125 28.8311 16C28.8311 23.0877 23.0847 28.834 15.9971 28.834C8.90957 28.8338 3.16406 23.0875 3.16406 16C3.16424 8.9126 8.90967 3.16717 15.9971 3.16699Z'
        stroke='#E0E0E0'
        strokeOpacity='0.1'
      />
      <path
        d='M16 21.3337L21.3333 16.0003L16 10.667'
        stroke='#6B7280'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6641 16H21.3307'
        stroke='#6B7280'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CloseSliderIcon;
